import styled from 'styled-components';
import {transparentize} from 'polished';

export const Wrapper = styled.div`
  
`;

export const Thumbnail = styled.img`
  border-radius: 5px;
  object-fit: cover;
  height: 500px;
  width: 100%;
`;

export const Content = styled.div`
  border-bottom: 1px solid ${({theme}) => `
    ${theme.variables.borderColor};
  `};
  margin: 30px 0;
  padding-bottom: 30px;
  row-gap: 20px;
  column-gap: 40px;
  grid-template-columns: 1fr auto;
  display: grid;
`;

export const Tags = styled.div`
  grid-row: 1;
  grid-column: 1;
  flex-wrap: wrap;
  display: flex;
  height: max-content;
  
  & > * {
    margin: 2px 4px 2px 0;
  }
`;

export const Title = styled.h1`
  margin: 0;
  grid-row: 2;
  grid-column: 1;
  line-height: 42px;
  font-weight: 700;
  font-size: 36px;
`;

export const Description = styled.p`
  margin: 0;
  grid-row: 3;
  grid-column: 1;
  line-height: 24px;
  font-size: 16px;
  color: ${({theme}) => `
    ${transparentize(.2, theme.variables.color)};
  `};
`;

export const Sidebar = styled.div`
  grid-column: 2;
  grid-row: span 3;
`;
